import { render } from "./ProgrammingView.vue?vue&type=template&id=475965a1"
import script from "./ProgrammingView.vue?vue&type=script&lang=js"
export * from "./ProgrammingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__